import { useState } from "react";
import { copyToClipboard } from "../../lib/clipboard";
import { useT } from "../../i18n/I18nProvider";

// Copy-to-clipboard button with a brief "Copied!" flash. Wraps the
// async clipboard API + an execCommand fallback so it still works
// in sandboxed marketplace iframes that block navigator.clipboard.
//
// Optional label prop lets callers customise the idle text — e.g.
// the intake-form card uses the localised "Copy" word in the
// operator's language but could surface a different label in
// other contexts later.
export function CopyButton({ text, label }: { text: string; label?: string }) {
  const t = useT();
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        try { await copyToClipboard(text); } catch { /* user can re-select */ }
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }}
    >
      {copied ? t("common.copied") : (label ?? t("common.copy"))}
    </button>
  );
}
